import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MainComponent } from './main/main.component';

// export const AppRoutes: Routes = [
//   {
//     path: '',
//     redirectTo: 'session',
//     pathMatch: 'full',
//   },
//   {
//     path: 'session', loadChildren: () =>
//       import('./session/session.module').then(m => m.SessionDemoModule)
//   },
//   {
//     path: '',
//     component: MainComponent,
//     canActivate: [AuthGuard],
//     runGuardsAndResolvers: 'always',
//     children: [
//       {
//         path: 'tools', loadChildren: () =>
//           import('./tools/tools.module').then(m => m.ToolsModule)
//       },
//     ],
//   },
// ];

export const AppRoutes: Routes = [
  {
    path: '',
    component: MainComponent, // Load MainComponent first
    children: [
      {
        path: 'session',
        loadChildren: () =>
          import('./session/session.module').then(m => m.SessionDemoModule),
      },
      {
        path: 'tools',
        //canActivate: [AuthGuard], // Protect tools route
        loadChildren: () =>
          import('./tools/tools.module').then(m => m.ToolsModule),
      },
      {
        path: 'privacy-policy',
        //canActivate: [AuthGuard], // Protect tools route
        loadChildren: () =>
          import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
      },
      {
        path: 'terms-of-service',
        //canActivate: [AuthGuard], // Protect tools route
        loadChildren: () =>
          import('./terms-of-service/terms-of-service.module').then(m => m.TermsOfServiceModule),
      },
      {
        path: 'data-deletion-instructions',
        //canActivate: [AuthGuard], // Protect tools route
        loadChildren: () =>
          import('./data-deletion-instructions/data-deletion-instructions.module').then(m => m.DataDeletionInstructionsModule),
      },
      {
        path: '',
        redirectTo: 'session', // Redirect to session after MainComponent loads
        pathMatch: 'full',
      }
    ],
  },
];

// export const AppRoutes: Routes = [
//   // ✅ Redirect root path only if nothing is provided
//   {
//     path: '',
//     redirectTo: 'session',
//     pathMatch: 'full',
//   },
//   {
//     path: '',
//     component: MainComponent,
//     children: [
//       {
//         path: 'session',
//         loadChildren: () =>
//           import('./session/session.module').then(m => m.SessionDemoModule),
//       },
//       {
//         path: 'tools',
//         loadChildren: () =>
//           import('./tools/tools.module').then(m => m.ToolsModule),
//       },
//       {
//         path: 'privacy-policy',
//         loadChildren: () =>
//           import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
//       },
//       {
//         path: 'terms-of-service',
//         loadChildren: () =>
//           import('./terms-of-service/terms-of-service.module').then(m => m.TermsOfServiceModule),
//       },
//       {
//         path: 'data-deletion-instructions',
//         loadChildren: () =>
//           import('./data-deletion-instructions/data-deletion-instructions.module').then(m => m.DataDeletionInstructionsModule),
//       }
//     ]
//   }
// ];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: []
})
export class RoutingModule { }